// extracted by mini-css-extract-plugin
module.exports = {"root":"LogToSpotify_root__xkT6k","entry":"LogToSpotify_entry__2M9hx","desc":"LogToSpotify_desc__2z08m"};